module.exports = __webpack_public_path__ + "img/avatar.453842fd.png";